import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { GetCouriers, GetLocations } from "../../api's/onboarding";


export const fetchAllLocations = createAsyncThunk(
  "locations/GetAllLocations",async ({token,toggle}, thunkAPI) => {
    try {      
      const response = await GetLocations(token,toggle);
      const data = response?.data ? response?.data : null;
      if (data) {
        if (data?.data?.is_success) {
          return data?.data ? data?.data : null;
          
        } else {
          return thunkAPI.rejectWithValue(data?.data);
        }
      } else {
        return thunkAPI.rejectWithValue("Unkonwn error occured");
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);


const locationSlice = createSlice({
  name: "Locations",

  initialState: {
    locationList: [],
    status: null,
    is_success:true, 
  },
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllLocations.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchAllLocations.fulfilled, (state, action) => {
        state.status = action?.payload?.status;
        state.locationList =  Array.isArray(action?.payload?.data?.data) ? action?.payload?.data?.data : [];
        state.is_success = action?.payload?.is_success // Populate state with fetched data
      })
      .addCase(fetchAllLocations.rejected, (state, action) => {
        state.is_success=action?.payload?.is_success || false
        state.status = action?.payload?.status || "Unkonwn error occured";
        state.locationList=[];
      });
  },

});

//selector ref to get the state  
export const selectLocationState = (state) => state.Locations;
export const locationReducer = locationSlice.reducer;